<template>
	<van-tabs
		v-model="index"
		@change="onChange"
		@disabled="onClickDisabled"
		title-active-color="#1592E6"
		color="#1592E6"
		swipeable
		sticky
	>
		<div v-for="(item, i) in list" :key="item.id">
			<van-tab :title="item.title" :disabled="item.auth == true && (companyId == '' || token == '')">
				<router-view v-if="index == i"></router-view>
			</van-tab>
		</div>
	</van-tabs>
</template>

<script>
import Vue from 'vue'
import { Toast } from 'vant'
import { mapGetters } from 'vuex'
Vue.use(Toast)
export default {
	props: ['list'],
	data() {
		return {
			index: 0,
		}
	},
	methods: {
		onChange(targetIndex) {
			this.index = targetIndex
			this.$parent.tabId = this.list[targetIndex].name
		},
		onClickDisabled() {
			Toast('用户无权访问')
		},
	},
	created() {
		for (var targetIndex in this.list) {
			if (this.list[targetIndex].name == this.$parent.tabId) {
				this.index = targetIndex
				break
			}
		}
	},
	computed: {
		...mapGetters(['token', 'userId', 'communityId', 'companyId']),
	},
}
</script>

<style>
.van-tab {
	font-size: 0.9375rem;
}
</style>
